import React from 'react';
import ReactDOM from 'react-dom/client';
// NOTE: this import stays ABOVE the App import, and this file is left out of
// the import-order sort. `index.css` and `src/styles/global.css` both define
// `body` and `code`; global.css is pulled in through the App tree, so it only
// wins — and only keeps the InterRegular font — while index.css is imported
// first. Sorting this line to the bottom silently changes the app's font.
import './index.css';
//import App from './components/App';
import { App } from 'src/components/App';
import { PUBLIC_ENV } from 'src/constants/env';
//import reportWebVitals from './reportWebVitals';
import { silenceDebugConsole } from 'src/utils/productionConsole';
import { reportWebVitals } from 'src/utils/reportWebVitals';

// Before anything renders, so no module's first log escapes (CASA finding 21).
silenceDebugConsole(PUBLIC_ENV);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
